import {Component, OnInit} from '@angular/core';
import {GlobalLoaderService} from '../../services/global-loader.service';
import {ApiAgentService} from '../../services/api-agent.service';
import {TranslateModule} from '@ngx-translate/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {CommonModule} from '@angular/common';
import {RouterModule} from '@angular/router';

@Component({
  selector: 'app-clients',
  templateUrl: './clients.component.html',
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, TranslateModule, RouterModule],
  styleUrls: ['./clients.component.scss']
})
export class ClientsComponent implements OnInit {

  loading: any;
  clients: any;

  /*
  createDate: "2020-04-14"
  createdBy: "system"
  id: 2108
  mobile: "0560040171"
  name: "متجر المبدع"
  password: "d51f38ff-6cc5-47af-8b83-9cf2b9d3678d"
  temporary: true
  updateDate: "2020-04-14"
  updatedBy: "system"
  validatedMobile: null
  validationCode: null
  * */

  constructor(private loader: GlobalLoaderService,
              private api: ApiAgentService) {
  }

  async ngOnInit() {
    this.loading = true;
    setTimeout(async () => {
      await this.loadResources();
      this.clients = await this.api.getClients();
      console.log('clients', this.clients);
      this.loading = false;
    }, 1000);
  }

  private async loadResources() {
    await this.loader.loadExternalStyles('/assets/css/forms/theme-checkbox-radio.css');
    await this.loader.loadExternalStyles('/plugins/jquery-ui/jquery-ui.min.css');
    await this.loader.loadExternalStyles('/assets/css/apps/contacts.css');
    await this.loader.loadExternalScript('/plugins/jquery-ui/jquery-ui.min.js');
    await this.loader.loadExternalScript('/assets/js/apps/contact.js');
  }
}
